@import 'styles/mixins';
@import 'styles/variables';

.root {
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: row-reverse;
  margin-left: 4px;
}

.strokeContainer {
  position: absolute;
  left: 2px;
  display: flex;
}

.stroke {
  border-radius: 50%;
}

.stacked {
  background: var(--neutral-0);
  padding: 2px;
  border-radius: 50%;
  margin-left: -4px;
  z-index: 1;
}

.dropdownItem {
  display: flex;

  .dropdownName {
    margin-left: 8px;
  }
}
